import type { AnyFieldApi, AnyFormApi } from '@tanstack/react-form';

import type { BorrowerData } from '../../../types';
import { getBorrowerAgeFromDate } from '../../../utils';

export function dateOfBirthListener(
  fieldApi: AnyFieldApi,
  formApi: AnyFormApi,
) {
  const dateOfBirth = fieldApi.state.value;

  formApi.setFieldValue(
    'age',
    Math.max(getBorrowerAgeFromDate(dateOfBirth), 0),
  );
}

export function isNameOrSsnChangedListener(
  formApi: AnyFormApi,
  queryData: BorrowerData,
) {
  const ssn = formApi.getFieldValue('socialSecurityNumber');
  const name = formApi.getFieldValue('lastName');

  const isNameOrSsnChanged =
    ssn !== queryData.formData.socialSecurityNumber ||
    name !== queryData.formData.lastName;

  formApi.setFieldValue('isNameOrSsnChanged', isNameOrSsnChanged);
}

export function isJoinedBorrowerChangedListener(
  fieldApi: AnyFieldApi,
  formApi: AnyFormApi,
  queryData: BorrowerData,
) {
  const joinedBorrowerId = fieldApi.state.value;

  const initialJoinedBorrowerId =
    queryData.formData.joinedBorrower?.borrowerRecordId;

  const isJoinedBorrowerChanged =
    String(joinedBorrowerId ?? '') !== String(initialJoinedBorrowerId ?? '');

  formApi.setFieldValue('isJoinedBorrowerChanged', isJoinedBorrowerChanged);
}
